import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'checkbox',
    templateUrl: 'checkbox.html',
    styleUrls: ['../field-abstract/icon-field.scss', 'checkbox.scss']
})
export class CheckboxComponent {
    @Input()
    alignCenter?: boolean;
}
